import { motion } from 'framer-motion';
import styles from './Projects.module.scss';
import { useInView } from 'react-intersection-observer';
import { useTranslation } from 'react-i18next';
import PDFViewer from '../components/PDFViewer';

const Projects = () => {
  const { t } = useTranslation();
  const [ref, inView] = useInView({
    threshold: 0.1,
    triggerOnce: true
  });

  return (
    <section ref={ref} className={styles.projects} id="projects">
      <motion.div
        initial={{ opacity: 0 }}
        animate={inView ? { opacity: 1 } : {}}
        transition={{ duration: 0.8 }}
        className={styles.content}
      >
        <motion.h2
          initial={{ y: 20, opacity: 0 }}
          animate={inView ? { y: 0, opacity: 1 } : {}}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          {t('projects.title')}
        </motion.h2>
        <div className={styles.projectsGrid}>
          {t('projects.items', { returnObjects: true }).map((project, index) => (
            <motion.div 
              key={index}
              className={styles.projectCard}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ 
                duration: 0.5, 
                delay: index * 0.1,
                ease: "easeOut"
              }}
            >
              <div className={styles.cardContent}>
                <div>
                  <div className={styles.header}>
                    <h3>{project.title}</h3>
                    <p className={styles.description}>{project.description}</p>
                  </div>
                  
                  <div className={styles.details}>
                    <ul>
                      {project.details.map((detail, idx) => (
                        <motion.li 
                          key={idx}
                          initial={{ opacity: 0, x: -20 }}
                          whileInView={{ opacity: 1, x: 0 }}
                          transition={{ delay: idx * 0.1 + 0.3 }}
                        >
                          {detail}
                        </motion.li>
                      ))}
                    </ul>
                  </div>

                  <div className={styles.technologies}>
                    {project.technologies.map((tech, idx) => (
                      <motion.span 
                        key={idx} 
                        className={styles.tech}
                        initial={{ opacity: 0, scale: 0.8 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        whileHover={{ scale: 1.05 }}
                        transition={{ delay: idx * 0.05 }}
                      >
                        {tech}
                      </motion.span>
                    ))}
                  </div>
                </div>

                {project.documentation && (
                  <motion.div
                    className={styles.pdfViewerWrapper}
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{ delay: 0.5 }}
                  >
                    <PDFViewer 
                      pdfUrl={`/${project.documentation}`}
                      title={t('projects.documentation')}
                    />
                  </motion.div>
                )}
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </section>
  );
};

export default Projects; 